import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './tgc-world.css';

const previewVariant = new URLSearchParams(window.location.search).get('imagery');
if (previewVariant === 'classic') {
  document.documentElement.dataset.tgcImagery = 'classic';
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
